import React from 'react';
import { ReferenceField } from 'react-admin';

export const LOCATIONS_INFO_RESOURCE = 'locations/info';

const LocationInfoValueField = ({ record, source, render, emptyText }) => {
    if (!record) return <span>{emptyText}</span>;

    const value = render ? render(record[source], record) : record[source];

    return <span>{value || emptyText}</span>;
};

LocationInfoValueField.defaultProps = {
    emptyText: '',
};

export const LocationInfoField = ({ infoSource, emptyText, render, ...props }) => (
    <ReferenceField
        {...props}
        reference={LOCATIONS_INFO_RESOURCE}
        linkType={false}
        allowEmpty
    >
        <LocationInfoValueField
            source={infoSource}
            render={render}
            emptyText={emptyText}
        />
    </ReferenceField>
);

LocationInfoField.defaultProps = {
    infoSource: 'name',
    emptyText: '',
};

export const renderLocationInfoColumns = ({ source, locationLabel, addressLabel }) => [
    <LocationInfoField
        key={`${source}-name`}
        label={locationLabel}
        source={source}
    />,
    <LocationInfoField
        key={`${source}-address`}
        label={addressLabel}
        source={source}
        infoSource="address"
    />,
];

